import { entries } from "store/entries";

export const getFavoriteApps = (user) => {
  if (!user) return undefined;
  if (user === 0) return undefined;
  return Array.from(entries.values()).filter(
    (entry) => entry.type === "app" && user.favoriteApps.includes(entry.name)
  );
};
